import C, { useState as w, useEffect as fn, useCallback as f, useMemo as gn } from "react";
import q from "classnames";
import { isPastDate as A } from "./index69.mjs";
import { generateDatesArray as An } from "./index70.mjs";
import { generateDateMap as Y } from "./index71.mjs";
import { generateNumberArray as Bn } from "./index72.mjs";
import i from "./index73.mjs";
import { isMobile as mn } from "./index74.mjs";
import { areDatesEqual as yn, getDaysDifference as Hn, Tooltip as Pn } from "@amenitiz/design-system";
import { useSetAtom as Kn, useAtom as On } from "jotai";
import { isEditSearchAtom as Un, restrictedDateClickedAtom as jn } from "./index26.mjs";
const qn = ({
  dayContainerStyles: e,
  date: r
}) => /* @__PURE__ */ C.createElement(
  "div",
  {
    "data-testid": `calendar-day-container-${r.toDateString()}`,
    className: e
  },
  /* @__PURE__ */ C.createElement("span", { "data-testid": `calendar-day-number-${r.toDateString()}` }, r.getDate())
), Fn = ({
  dateFrom: e,
  dateTo: r,
  setDateFrom: H,
  setDateTo: P,
  days: pn,
  previousDays: z,
  year: Dn,
  month: bn,
  isWithinLimit: u,
  checkIfAvailable: G,
  getAvailabilityForDate: o,
  getFirstUnavailableDate: J,
  scopedMap: Q,
  setScopedMap: D,
  setWarning: y,
  timeLimitCustomMessage: E
}) => {
  const [B, R] = w(null), [I, V] = w(!1), [l, X] = w(
    null
  ), [c, hn] = w(null), [K, g] = w(""), O = mn(navigator.userAgent), Z = Kn(Un), [T, kn] = On(
    jn
  ), [vn, Sn] = w(null), U = T !== void 0 ? T : vn, S = kn || Sn;
  fn(() => {
    hn(o(e) || null);
  }, [e, o]);
  const b = f(
    (n) => {
      if (!e)
        return !1;
      const t = c == null ? void 0 : c.min_stay;
      if (!t)
        return !1;
      const s = new Date(e);
      return s.setDate(s.getDate() + t), n < s;
    },
    [e, c]
  ), h = f(
    (n) => {
      if (!e)
        return !1;
      const t = c == null ? void 0 : c.max_stay;
      if (!t)
        return !1;
      const s = new Date(e);
      return s.setDate(s.getDate() + t), n > s;
    },
    [e, c]
  ), L = f(
    (n) => !e || A(n, e) || yn(n, e) || r ? !0 : !(b(n) || h(n)),
    [e, r, b, h]
  ), $ = f(
    (n) => {
      if (A(n) || u(n) && !E)
        return !1;
      if (e && (l == null ? void 0 : l.toDateString()) === n.toDateString())
        return !0;
      const t = o(n);
      return t ? t.closed ? !1 : t.is_available : !0;
    },
    [
      o,
      e,
      l,
      u,
      E
    ]
  ), W = f(
    (n) => {
      if (!e)
        return !0;
      if (l && l < n)
        return !1;
      const t = o(n);
      return t && t.closed_to_departure ? !1 : L(n);
    },
    [
      e,
      l,
      L,
      o
    ]
  ), j = f(
    (n) => {
      const t = o(n);
      return t && t.closed_to_arrival ? !1 : !u(n);
    },
    [o, u]
  ), F = f(
    (n) => {
      const t = o(n);
      return [
        t != null && t.closed_to_departure ? "closed_to_departure" : null,
        b(n) ? "min_stay" : null,
        h(n) ? "max_stay" : null,
        u(n) ? "time_limit" : null
      ].filter(
        (s) => s !== null
      );
    },
    [
      o,
      b,
      h,
      u
    ]
  ), nn = f(
    (n) => {
      if (n.length === 0)
        return null;
      const t = n[0];
      if (!t)
        return null;
      if (n.length === 1)
        return t;
      const s = n.includes("min_stay"), a = n.includes("max_stay"), p = n.includes("closed_to_departure");
      return s && a ? "min_and_max_stay" : p && s ? "closed_to_departure_and_min_stay" : p && a ? "closed_to_departure_and_max_stay" : t;
    },
    []
  ), m = f(
    (n) => {
      const t = !e, s = e && !r, a = e && r && e.toDateString() !== n.toDateString() && r.toDateString() !== n.toDateString();
      if (t) {
        if (!j(n)) {
          if (S(n), u(n)) {
            y({
              type: "time_limit",
              customMessage: E || void 0
            });
            return;
          }
          y({ type: "closed_to_arrival" });
          return;
        }
        H(n), S(null), y({ type: null });
        return;
      }
      if (s) {
        if (!W(n)) {
          S(n);
          const p = F(n), k = nn(p);
          y(k === "time_limit" ? {
            type: k,
            customMessage: E || void 0
          } : { type: k });
          return;
        }
        P(n), R(null), g(""), Z(!1), y({ type: null }), S(null);
        return;
      }
      if (a) {
        if (!j(n)) {
          S(n), y({ type: "closed_to_arrival" });
          return;
        }
        H(n), P(null), D(/* @__PURE__ */ new Map()), y({ type: null }), S(null);
      }
    },
    [
      e,
      r,
      D,
      H,
      P,
      Z,
      W,
      j,
      F,
      nn,
      y,
      u,
      E,
      S
    ]
  ), en = f(
    (n) => {
      if ((!e || e && r) && !$(n)) {
        g(
          `${I18n.t("booking_engine.date_picker.tooltip.unavailable")}`
        );
        return;
      }
      const t = o(n);
      if ((!e || e && r) && t && t.closed_to_arrival) {
        g(
          `${I18n.t("booking_engine.date_picker.tooltip.closed_to_arrival")}`
        );
        return;
      }
      if ((!e || e && r) && t && u(n)) {
        g(
          `${I18n.t("booking_engine.date_picker.tooltip.unavailable")}`
        );
        return;
      }
      if (!e || A(n, e) || e && yn(n, e) || r) {
        g("");
        return;
      }
      if (l && l < n) {
        g(
          `${I18n.t("booking_engine.date_picker.tooltip.unavailable")}`
        ), R(n), D(Y(e, n));
        return;
      }
      if (!$(n)) {
        g(
          `${I18n.t("booking_engine.date_picker.tooltip.unavailable")}`
        );
        return;
      }
      if (e.getMonth() !== n.getMonth() && !G(e, n)) {
        g(
          `${I18n.t("booking_engine.date_picker.tooltip.unavailable")}`
        );
        return;
      }
      const s = [];
      if (t && t.closed_to_departure && s.push(
        I18n.t("booking_engine.date_picker.tooltip.closed_to_departure")
      ), b(n)) {
        const M = c == null ? void 0 : c.min_stay;
        s.push(
          `${M} ${I18n.t("booking_engine.date_picker.tooltip.min_nights_restriction")}`
        );
      }
      if (h(n)) {
        const M = c == null ? void 0 : c.max_stay;
        s.push(
          `${M} ${I18n.t("booking_engine.date_picker.tooltip.max_nights_restriction")}`
        );
      }
      if (s.length > 0) {
        g(s.join(`
`)), R(n), D(Y(e, n));
        return;
      }
      const v = Hn(e, n).toString();
      g(
        v === "1" ? I18n.t("booking_engine.information.nights.one", {
          count: v
        }) : I18n.t("booking_engine.information.nights.other", {
          count: v
        })
      ), R(n), D(Y(e, n));
    },
    [
      e,
      b,
      h,
      r,
      D,
      G,
      c,
      $,
      l,
      o,
      u
    ]
  ), tn = f(() => {
    R(null), r || D(/* @__PURE__ */ new Map());
  }, [r, D]), sn = An(pn, Dn, bn);
  fn(() => {
    X(e && !r ? J(e) : null);
  }, [e, r, J]);
  const dn = gn(() => Bn(z).map((n) => /* @__PURE__ */ C.createElement("div", { "data-testid": "previous-day", key: n, className: i.day }, " ")), [z]), Cn = gn(() => sn.map((n) => {
    var un, _n;
    const t = e && n.toDateString() === e.toDateString(), s = r && n.toDateString() === r.toDateString(), a = U && n.toDateString() === U.toDateString(), p = B && n.toDateString() === B.toDateString(), k = !!(t || s), v = !$(n), M = !!(k || p), d = !k && !v && (!l || l >= n), rn = !!Q.get(n.toDateString()), N = !e || r ? !A(n) : !A(n, e), x = d && N && !I, In = (un = o(n)) == null ? void 0 : un.closed_to_arrival, on = d && N && !a && !I && In, Nn = (_n = o(n)) == null ? void 0 : _n.closed_to_departure, ln = e && d && N && !a && !I && Nn, cn = e && d && N && !a && !I && (b(n) || h(n)), an = e && v || l && l < n, xn = d && N && !a && !I && u(n), wn = q({
      [i.day_container]: !0,
      [i.day_container_available]: d && N && !a,
      [i.day_container_selected]: M && !an && !on && !ln && !a && !cn,
      [i.day_container_from]: (r || B) && t,
      [i.day_container_to]: (s || p) && !a,
      [i.day_container_unavailable]: v,
      [i.day_container_available_with_closed_to_arrival]: on,
      [i.day_container_available_with_closed_to_departure]: ln,
      [i.day_container_unavailable_or_after_first_unavailable_date]: an,
      [i.day_container_available_with_restrictions]: cn,
      [i.day_container_available_with_time_limit]: xn,
      [i.day_container_restricted_date_clicked]: a
    }), En = q({
      [i.day]: !0,
      [i.day_from]: rn && t,
      [i.day_to]: s || p,
      [i.day_scoped]: rn,
      [`available-${n.getMonth()}-${n.getFullYear()}`]: d
    }), Rn = (_) => _.toLocaleDateString(I18n.locale, {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    }), $n = () => {
      const _ = Rn(n);
      if (k) {
        if (t)
          return I18n.t(
            "booking_engine.accessibility.calendar_day_selected_arrival",
            {
              date: _
            }
          );
        if (s)
          return I18n.t(
            "booking_engine.accessibility.calendar_day_selected_departure",
            {
              date: _
            }
          );
      }
      return v ? I18n.t(
        "booking_engine.accessibility.calendar_day_unavailable",
        {
          date: _
        }
      ) : x ? I18n.t("booking_engine.accessibility.calendar_day_available", {
        date: _
      }) : I18n.t("booking_engine.accessibility.calendar_day", {
        date: _
      });
    }, Mn = (_) => {
      (_.key === "Enter" || _.key === " ") && (_.preventDefault(), x && m(n));
    };
    return /* @__PURE__ */ C.createElement(
      "button",
      {
        "data-testid": "calendar-day",
        role: "button",
        tabIndex: x ? 0 : -1,
        key: n.toDateString(),
        className: En,
        "aria-label": $n(),
        onClick: () => x && m(n),
        onKeyDown: Mn,
        onTouchStart: () => V(!1),
        onTouchMove: () => V(!0),
        onTouchEnd: () => x && m(n),
        onMouseEnter: () => !O && en(n),
        onMouseLeave: () => !O && tn(),
        disabled: !x,
        type: "button"
      },
      /* @__PURE__ */ C.createElement(
        Pn,
        {
          content: K || "",
          position: "top",
          showArrow: !1,
          tooltipClasses: q(i.tooltip, {
            [i.hidden_tooltip]: K === ""
          })
        },
        /* @__PURE__ */ C.createElement(qn, { dayContainerStyles: wn, date: n })
      )
    );
  }), [
    sn,
    e,
    r,
    B,
    $,
    Q,
    tn,
    K,
    m,
    en,
    O,
    I,
    l,
    o,
    b,
    h,
    u,
    U
  ]);
  return /* @__PURE__ */ C.createElement("div", { "data-testid": "days-container", className: i.days_container }, dn, Cn);
};
export {
  Fn as Days
};
